import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const add_email = (
  mailUser,
  mailPassword,
  mailKey,
  smtpServeraddress,
  port,
  status,
  ip
) => {
  return api.post(`${ApiEndpointConstants.ADDEMAIL}`, {
    mailUser,
    mailPassword,
    mailKey,
    smtpServeraddress,
    port,
    status,
    ip: ip || "",
  });
};
